module.exports = __webpack_public_path__ + "img/Money-Bag.d4f514d1.svg";